import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const LazyLeadershipCornerBanner = () =>
  import(/* webpackChunkName: "4-feat-leadership-corner-banner" */ './LeadershipCornerBanner');

export default lazyLoadOnRender({ loader: LazyLeadershipCornerBanner });
